import React from "react";
import CandidateLayout from "./layout/dashboard";
export default function CandidateDashboard(appProps) {
  return (
    <CandidateLayout>
      <h1>Candidate Dashboard</h1>
    </CandidateLayout>
  );
}
